/*
 * Module for the Insurance edit view
*/
rs.module("content/system/configuration/availablepaycomponent/availabilitytab",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {
        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, columnIds, grid, ajaxUrl) {
            var availabilityForm = $.js(jsSelectors.availabilityForm);
            var addButton = $.js(jsSelectors.addButton);

            var fundSelector = availabilityForm.js(jsSelectors.fundSelector);
            var fundSelectHelper = selectHelper.getHelper(fundSelector);
            var effectiveDate = availabilityForm.js(jsSelectors.effectiveDate);
            var terminationDate = availabilityForm.js(jsSelectors.terminationDate);
            var updateToken = availabilityForm.js(jsSelectors.updateToken);
            var componentAssociationKey = availabilityForm.js(jsSelectors.componentAssociationKey);

            // update the editable controls when grid selection changes
            if (grid) {
                grid.selectionChanged(function (values, rows) {
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();
                        $.get(
                            ajaxUrl,
                            { componentAssociationKey: rows[0][columnIds.componentAssociationKey] },

                            function (data) {
                                fundSelectHelper.setValue(data.fundKey);
                                fundSelector.clearErrors();
                                effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null).clearErrors();
                                terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null).clearErrors();
                                updateToken.val(data.updateToken);
                                componentAssociationKey.val(rows[0][columnIds.componentAssociationKey]);
                            }
                        );
                    }
                });
            }

            // clear the editable controls and errors
            addButton.click(function () {
                eventBanner.removeAllMessages();

                fundSelectHelper.setValue(null);
                effectiveDate.val(null);
                terminationDate.val(null);
                componentAssociationKey.val(-1);

                grid.selectedValues = null;
            });

            _executeSelectionChanged = true;
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);